import { create, type StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import {
  calculationDetailSlice,
  type CalculationDetailSlice,
} from "@/pages/CalculationDetail/store/calculationDetailSlice";
import {
  formulaReferenceSlice,
  type FormulaReferenceSlice,
} from "@/pages/CalculationDetail/store/formulaReferenceSlice";
import {
  operationalDataSlice,
  type OperationalDataSlice,
} from "@/pages/OperationalData/store/operationalDataSlice";

export type TrackWiseStore = CalculationDetailSlice &
  FormulaReferenceSlice &
  OperationalDataSlice;

type Slice<T> = StateCreator<TrackWiseStore, [["zustand/immer", never]], [], T>;

export const useStore = create<TrackWiseStore>()(
  devtools(
    immer((...a) => ({
      ...(calculationDetailSlice as Slice<CalculationDetailSlice>)(...a),
      ...(formulaReferenceSlice as Slice<FormulaReferenceSlice>)(...a),
      ...(operationalDataSlice as Slice<OperationalDataSlice>)(...a),
    })),
    { name: "TrackWise", enabled: import.meta.env.VITE_ENV !== "production" },
  ),
);
